import React from 'react'

import { Box, CircularProgress } from '@mui/material'

type LoadingViewProps = {
  children?: React.ReactNode
  className?: string
  error?: React.ReactNode
  loading?: boolean
  size?: number
}

const LoadingView = ({ children, error, loading = false, size = 60, className }: LoadingViewProps) =>
  loading ? (
    <Box className={className} sx={{ padding: '3rem', textAlign: 'center' }}>
      <CircularProgress size={size} />
    </Box>
  ) : error ? (
    <Box sx={{ padding: '3rem', textAlign: 'center' }}>{error}</Box>
  ) : (
    <>{children}</>
  )

export default LoadingView
